export default __webpack_public_path__ + "images/89202fb6f2e12db99010391dfb57fba3.png";